import Animation from './Animation';
import DOMUtils from '../dom/DOMUtils';
import ElementStyleAnimationOptions from './ElementStyleAnimationOptions';
export default class ElementStyleAnimation extends Animation {
    constructor(element, options) {
        super(options);
        this.element = element;
        this.derivedOptions = new ElementStyleAnimationOptions(options);
        this.originalProgressFunction = this.options.progressFunction;
        this.options.progressFunction = this.progressFunction.bind(this);
        this.initInitialPropertyValues();
    }
    initInitialPropertyValues() {
        for (const propertyName in this.derivedOptions.targetPropertyValues) {
            const typedPropertyName = propertyName;
            if (!(propertyName in this.derivedOptions.initialPropertyValues)) {
                this.derivedOptions.initialPropertyValues[typedPropertyName] = DOMUtils.getComputedNumericValue(this.element, typedPropertyName);
            }
        }
    }
    progressFunction(sender, effectiveProgress) {
        for (const propertyName in this.derivedOptions.targetPropertyValues) {
            const typedPropertyName = propertyName;
            if (this.derivedOptions.targetPropertyValues[typedPropertyName].value === undefined) {
                continue;
            }
            const newValue = this.derivedOptions.initialPropertyValues[typedPropertyName] +
                (this.derivedOptions.targetPropertyValues[typedPropertyName].value - this.derivedOptions.initialPropertyValues[typedPropertyName]) * effectiveProgress;
            DOMUtils.setNumericValue(this.element, typedPropertyName, newValue, this.derivedOptions.targetPropertyValues[typedPropertyName].unit);
        }
        if (effectiveProgress === 1 && this.derivedOptions.clearStyleOnComplete) {
            for (const propertyName in this.derivedOptions.targetPropertyValues) {
                DOMUtils.clearValue(this.element, propertyName);
            }
        }
        if (this.originalProgressFunction) {
            this.originalProgressFunction(this, effectiveProgress);
        }
    }
}
//# sourceMappingURL=ElementStyleAnimation.js.map